// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import Menu from "./Menu";
// import QuestionTable from "./QuestionTable";
import UploadSubjectJson from "./JsonUploader";
import TopicMover from "./TopicMover";
// import Home from "./Home";
import AdminPage from "./AdminPage";
import Home from "./Home/Home";
import Navbar from "./Components/Navbar";
import HomeOld from "./Home";


const App = () => {
  return (
    <Router>
      {/* <Navbar/> */}
      <nav style={styles.navbar}>
      
        {/* <Link to="/" style={styles.link}>Home</Link> */}
         <Link to="/" style={styles.link}>Home</Link>
        <Link to="/admin" style={styles.link}>Admin</Link>
        <Link to="/upload" style={styles.link}>Upload JSON</Link>
          <Link to="/move" style={styles.link}>Move</Link>
            <Link to="/sanju" style={styles.link}>Demo</Link>
      </nav>

      <Routes>
                <Route path="/" element={<HomeOld />} />

        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/upload" element={<UploadSubjectJson />} />
         <Route path="/move" element={<TopicMover />} />
         <Route path="/sanju" element={<Menu />} />
                  {/* <Route path="/Home" element={<Home />} /> */}

      </Routes>
    </Router>
  );
};

const styles = {
  navbar: {
    display: "flex",
    gap: "1rem",
    padding: "1rem",
    backgroundColor: "#f5f5f5",
    borderBottom: "1px solid #ddd",
    marginBottom: "1rem",
  },
  link: {
    textDecoration: "none",
    fontWeight: "bold",
    color: "#007bff",
  },
};

export default App;

